import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../../ui/TextField";
import DataSelect from "../../../../../../ui/DataSelect";
import useResourceForm from "./useResourceForm";
import { Typography } from "@material-ui/core";

const defaultData = {
  assign: "",
  name: "",
  url: "",
  siteAccess: null,
  organization: null,
  department: null
};

const styles = () => ({
  root: {
    padding: 8,
    maxWidth: 774,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  block: {
    margin: "35px 0 15px 0"
  }
});

const ResourceForm = ({ disabled, onFormChange, initialData, classes, editmode }) => {
  const [data, setData] = React.useState(initialData || defaultData);
  const {
    dataSources,
    getAccessTypeList,
    getOrganizationsList,
    getDepartmentsList
  } = useResourceForm();
  const {
    assign,
    name,
    url,
    siteAccess,
    organization,
    department
  } = data;

  useEffect(() => {
    getAccessTypeList();
    getOrganizationsList();
  }, []);

  useEffect(() => {
    onChange("department", null);
    if (organization) getDepartmentsList(organization);
  }, [organization]);

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };

  return (
    <div className={classes.root}>
      <Typography className={classes.heading}>Параметры ресурса</Typography>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <TextField
            value={name}
            onChange={e => onChange("name", e.target.value)}
            label="Название"
            disabled={disabled}
            readOnly={!editmode}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            value={assign}
            onChange={e => onChange("assign", e.target.value)}
            label="Назначение"
            disabled={disabled}
            readOnly={!editmode}
            required
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            value={url}
            onChange={e => onChange("url", e.target.value)}
            label="Ссылка"
            disabled={disabled}
            readOnly={!editmode}
            required
          />
        </Grid>
        <Grid item xs={6}>
          <DataSelect
            value={organization}
            onChange={value => onChange("organization", value.id)}
            label="Организация"
            dataSource={dataSources.organizations}
            disabled={disabled || !editmode}
          />
        </Grid>
        <Grid item xs={6}>
          <DataSelect
            value={siteAccess}
            onChange={value => onChange("siteAccess", value.id)}
            label="Доступ к ресурсу"
            dataSource={dataSources.accessTypes}
            disabled={disabled || !editmode}
          />
        </Grid>
        <Grid item xs={6}>
          <DataSelect
            value={department}
            onChange={value => onChange("department", value.id)}
            label="Подразделение"
            dataSource={dataSources.departments}
            disabled={disabled || !editmode}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(styles)(ResourceForm);
